import { CommonModule } from "@angular/common";
import { Component, Inject, Input, OnInit } from "@angular/core";
import {
  ReactiveFormsModule,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import Swal from "sweetalert2";
import { CategoryService } from "../category.service";
import { Modal } from "bootstrap";
import { ModalService } from "../../../components/modal/service/modal.service";

@Component({
  selector: "app-category-form",
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: "./category-form.component.html",
  styleUrl: "./category-form.component.scss",
})
export class CategoryFormComponent implements OnInit {
  form: UntypedFormGroup;
  @Input() id?: string;

  constructor(
    private formBuilder: UntypedFormBuilder,
    @Inject(CategoryService) private categoryService: CategoryService,
    private modalService: ModalService
  ) {
    this.form = this.formBuilder.group({
      description: ["", Validators.required],
    });
  }

  async ngOnInit(): Promise<void> {
    if (this.id) {
      await this.categoryService.getById(this.id).then((res) => {
        this.form.patchValue({ ...res });
      });
    }
  }

  emitAction() {
    this.categoryService.sendAction("Ação enviada!");
  }

  async formSubmit() {
    if (this.form.invalid) {
      Swal.fire(
        "Atenção",
        "Existem campos obrigatórios que não foram preenchidos.",
        "warning"
      );
      return;
    } else {
      try {
        const formValue = {
          ...this.form.value,
        };

        if (this.id) {
          await this.categoryService
            .update(this.id, formValue)
            .then((res) => {
              this.modalService.closeModal();
              Swal.fire("Salvo", "Usuário salvo com sucesso!", "success");
              this.emitAction();
            })
            .catch((err) => {
              Swal.fire("Erro!", err.message, "error");
            });
        } else {
          await this.categoryService
            .create(formValue)
            .then((res) => {
              this.modalService.closeModal();
              Swal.fire("Salvo", "Usuário salvo com sucesso!", "success");
              this.emitAction();
            })
            .catch((err) => {
              Swal.fire("Erro!", err.message, "error");
            });
        }
      } catch (error) {
        Swal.fire(
          "Erro!",
          "Não foi possível salvar os seus dados. Tente novamente mais tarde.",
          "error"
        );
      }
    }
  }
}
